import apiService from "service/api";

export const createBranch = async (
  hfId: number,
  formData: Record<string, any>
) => {
  return apiService(
    `/healthfacilities/${hfId}/branch/`,
    "POST",
    formData,
    true
  );
};

export const updateBranch = async (
  branchId: string,
  formData: Record<string, any>
) => {
  return apiService(
    `/healthfacilities/${branchId}/update/`,
    "PUT",
    formData,
    true,
    {
      "Content-Type": "multipart/form-data",
    }
  );
};

export const getBranchDetails = async (branchId: string) => {
  return apiService(`/healthfacilities/${branchId}/`, "GET", null, true);
};

export const deleteBranch = async (hfId: number, branchId: number) => {
  return apiService(
    `/healthfacilities/${hfId}/branch/${branchId}/`,
    "DELETE",
    null,
    true
  );
};

export const getAllBranch = (hfId: number, page: any, size: number) => {
  return apiService(
    `/healthfacilities/${hfId}/branch/?page=${page}&size=${size}`,
    "GET",
    null,
    true
  );
};
